var map = {
	"./": 22974,
	"./App": 29833,
	"./App.test": 49089,
	"./App.test.tsx": 49089,
	"./App.tsx": 29833,
	"./assets/css/App.css": 61500,
	"./assets/css/index.css": 55481,
	"./assets/fonts/Gotham-Bold.ttf": 8681,
	"./assets/fonts/Gotham-Bold.woff": 32335,
	"./assets/fonts/Gotham-Bold.woff2": 40863,
	"./assets/fonts/Gotham-Book.ttf": 13519,
	"./assets/fonts/Gotham-Book.woff": 72285,
	"./assets/fonts/Gotham-Book.woff2": 77061,
	"./assets/fonts/Gotham-Light.ttf": 88808,
	"./assets/fonts/Gotham-Light.woff": 13736,
	"./assets/fonts/Gotham-Light.woff2": 74906,
	"./assets/images/APY.png": 33395,
	"./assets/images/LRTfocused-image.png": 63530,
	"./assets/images/LRTfocused-title.png": 88643,
	"./assets/images/adaptive-image.png": 21369,
	"./assets/images/adaptive-title.png": 38316,
	"./assets/images/amphrBTC.svg": 87138,
	"./assets/images/amphrETH.svg": 61446,
	"./assets/images/apr-title.png": 1253,
	"./assets/images/avs-logo.svg": 6527,
	"./assets/images/background-association.jpg": 15193,
	"./assets/images/background-level-down.png": 60005,
	"./assets/images/background-level-top.png": 57260,
	"./assets/images/background-metrics-mobile.jpg": 69904,
	"./assets/images/background-metrics.jpg": 59471,
	"./assets/images/background-service.png": 58537,
	"./assets/images/background-start.jpg": 87460,
	"./assets/images/background-vision-mobile.jpg": 21291,
	"./assets/images/background-vision.jpg": 57290,
	"./assets/images/focused-title.png": 59381,
	"./assets/images/gitbook.svg": 86558,
	"./assets/images/icon-auditor.svg": 35965,
	"./assets/images/icon-chain.svg": 69168,
	"./assets/images/icon-defillama.svg": 3222,
	"./assets/images/icon-liquidity.svg": 17999,
	"./assets/images/icon-powered.svg": 31175,
	"./assets/images/logo-footer.svg": 42138,
	"./assets/images/logo-icon-white.svg": 72628,
	"./assets/images/logo.svg": 3914,
	"./assets/images/mellowPoints.svg": 9542,
	"./assets/images/partners/aragon.png": 33573,
	"./assets/images/partners/bail-hover.svg": 15168,
	"./assets/images/partners/bail-security-hover.svg": 54261,
	"./assets/images/partners/bail-security.svg": 37504,
	"./assets/images/partners/base-hover.svg": 62223,
	"./assets/images/partners/base.svg": 95038,
	"./assets/images/partners/bedrock-hover.svg": 10920,
	"./assets/images/partners/bedrock.svg": 89149,
	"./assets/images/partners/blockscape.png": 40172,
	"./assets/images/partners/chorusone.png": 87905,
	"./assets/images/partners/eigen-hover.svg": 45158,
	"./assets/images/partners/eigen.svg": 81711,
	"./assets/images/partners/eigenda-hover.svg": 4867,
	"./assets/images/partners/eigenda.svg": 95810,
	"./assets/images/partners/ethena.png": 19706,
	"./assets/images/partners/ethereum-hover.svg": 43587,
	"./assets/images/partners/ethereum.svg": 96994,
	"./assets/images/partners/etherfi-hover.svg": 22597,
	"./assets/images/partners/etherfi.svg": 57392,
	"./assets/images/partners/euclid-hover.svg": 21372,
	"./assets/images/partners/euclid.svg": 39713,
	"./assets/images/partners/figment.jpg": 85985,
	"./assets/images/partners/hyperlane.svg": 2707,
	"./assets/images/partners/hyveda.svg": 40094,
	"./assets/images/partners/kelp-hover.svg": 78072,
	"./assets/images/partners/kelp.svg": 89709,
	"./assets/images/partners/kiln.svg": 2031,
	"./assets/images/partners/lombard.webp": 3522,
	"./assets/images/partners/luganodes.svg": 20975,
	"./assets/images/partners/mellow-hover.svg": 50040,
	"./assets/images/partners/mellow.svg": 94413,
	"./assets/images/partners/mev-capital-hover.svg": 55317,
	"./assets/images/partners/mev-capital.svg": 8064,
	"./assets/images/partners/nodeinfra.png": 72745,
	"./assets/images/partners/oxorio-hover.svg": 4322,
	"./assets/images/partners/oxorio.svg": 13611,
	"./assets/images/partners/polygon-hover.svg": 7720,
	"./assets/images/partners/polygon.svg": 29149,
	"./assets/images/partners/primev.png": 67326,
	"./assets/images/partners/redstone.png": 3963,
	"./assets/images/partners/renzo-hover.svg": 84900,
	"./assets/images/partners/renzo.svg": 67353,
	"./assets/images/partners/salus-hover.svg": 61814,
	"./assets/images/partners/salus.svg": 83391,
	"./assets/images/partners/sherlock-hover.svg": 95345,
	"./assets/images/partners/sherlock.svg": 4092,
	"./assets/images/partners/symbiotic-hover.svg": 44273,
	"./assets/images/partners/symbiotic.svg": 86716,
	"./assets/images/partners/xbto-hover.svg": 32265,
	"./assets/images/partners/xbto.svg": 37956,
	"./assets/images/partners/zircuit-hover.svg": 69002,
	"./assets/images/partners/zircuit.svg": 50915,
	"./assets/images/resilient-image.png": 75438,
	"./assets/images/resilient-title.png": 38271,
	"./assets/images/restakingAPR.svg": 39562,
	"./assets/images/stakingAPR.svg": 54205,
	"./assets/images/symbioticPoints.svg": 50607,
	"./assets/images/tvl-title.png": 11244,
	"./assets/images/v1-title.png": 33949,
	"./assets/videos/video-animation-service.mp4": 60850,
	"./assets/videos/video-particles-default.mp4": 63579,
	"./assets/videos/video-particles.mp4": 84123,
	"./assets/videos/video-start.mp4": 92662,
	"./components/BTCRestaking": 29113,
	"./components/BTCRestaking/": 29113,
	"./components/BTCRestaking/index": 29113,
	"./components/BTCRestaking/index.tsx": 29113,
	"./components/BackTop": 41638,
	"./components/BackTop/": 41638,
	"./components/BackTop/index": 41638,
	"./components/BackTop/index.tsx": 41638,
	"./components/ConnectWallet": 73689,
	"./components/ConnectWallet/": 73689,
	"./components/ConnectWallet/index": 73689,
	"./components/ConnectWallet/index.tsx": 73689,
	"./components/ETHRestaking": 1501,
	"./components/ETHRestaking/": 1501,
	"./components/ETHRestaking/index": 1501,
	"./components/ETHRestaking/index.tsx": 1501,
	"./components/HeaderAppBar": 95146,
	"./components/HeaderAppBar/": 95146,
	"./components/HeaderAppBar/index": 95146,
	"./components/HeaderAppBar/index.tsx": 95146,
	"./components/Loading": 3568,
	"./components/Loading/": 3568,
	"./components/Loading/index": 3568,
	"./components/Loading/index.tsx": 3568,
	"./components/LogoLink": 71861,
	"./components/LogoLink/": 71861,
	"./components/LogoLink/index": 71861,
	"./components/LogoLink/index.tsx": 71861,
	"./components/NumberCountUp": 93987,
	"./components/NumberCountUp/": 93987,
	"./components/NumberCountUp/index": 93987,
	"./components/NumberCountUp/index.tsx": 93987,
	"./components/OpenApp": 88261,
	"./components/OpenApp/": 88261,
	"./components/OpenApp/index": 88261,
	"./components/OpenApp/index.tsx": 88261,
	"./components/SocialLinks": 53895,
	"./components/SocialLinks/": 53895,
	"./components/SocialLinks/index": 53895,
	"./components/SocialLinks/index.tsx": 53895,
	"./components/StartsCountdown": 38900,
	"./components/StartsCountdown/": 38900,
	"./components/StartsCountdown/index": 38900,
	"./components/StartsCountdown/index.tsx": 38900,
	"./components/TitleIcon": 22153,
	"./components/TitleIcon/": 22153,
	"./components/TitleIcon/index": 22153,
	"./components/TitleIcon/index.tsx": 22153,
	"./components/TitleSection": 76267,
	"./components/TitleSection/": 76267,
	"./components/TitleSection/index": 76267,
	"./components/TitleSection/index.tsx": 76267,
	"./constants/urls": 60328,
	"./constants/urls.tsx": 60328,
	"./index": 22974,
	"./index.tsx": 22974,
	"./lib/utils": 36041,
	"./lib/utils.tsx": 36041,
	"./logo.svg": 69445,
	"./react-app-env.d": 55059,
	"./react-app-env.d.ts": 55059,
	"./reportWebVitals": 16469,
	"./reportWebVitals.ts": 16469,
	"./sections/Association": 45853,
	"./sections/Association/": 45853,
	"./sections/Association/index": 45853,
	"./sections/Association/index.tsx": 45853,
	"./sections/FAQ": 78400,
	"./sections/FAQ/": 78400,
	"./sections/FAQ/index": 78400,
	"./sections/FAQ/index.tsx": 78400,
	"./sections/FAQ/items": 19146,
	"./sections/FAQ/items.tsx": 19146,
	"./sections/Footer": 92282,
	"./sections/Footer/": 92282,
	"./sections/Footer/index": 92282,
	"./sections/Footer/index.tsx": 92282,
	"./sections/Metrics": 77211,
	"./sections/Metrics/": 77211,
	"./sections/Metrics/index": 77211,
	"./sections/Metrics/index.tsx": 77211,
	"./sections/NetworkExplorer": 9875,
	"./sections/NetworkExplorer/": 9875,
	"./sections/NetworkExplorer/index": 9875,
	"./sections/NetworkExplorer/index.tsx": 9875,
	"./sections/RestakenToken": 22701,
	"./sections/RestakenToken/": 22701,
	"./sections/RestakenToken/index": 22701,
	"./sections/RestakenToken/index.tsx": 22701,
	"./sections/Service": 31201,
	"./sections/Service/": 31201,
	"./sections/Service/index": 31201,
	"./sections/Service/index.tsx": 31201,
	"./sections/Start": 32320,
	"./sections/Start/": 32320,
	"./sections/Start/index": 32320,
	"./sections/Start/index.tsx": 32320,
	"./sections/Vision": 24616,
	"./sections/Vision/": 24616,
	"./sections/Vision/index": 24616,
	"./sections/Vision/index.tsx": 24616,
	"./sections/Why": 79214,
	"./sections/Why/": 79214,
	"./sections/Why/Adaptative": 76931,
	"./sections/Why/Adaptative.tsx": 76931,
	"./sections/Why/LRTFocused": 70401,
	"./sections/Why/LRTFocused.tsx": 70401,
	"./sections/Why/Resilient": 30791,
	"./sections/Why/Resilient.tsx": 30791,
	"./sections/Why/index": 79214,
	"./sections/Why/index.tsx": 79214,
	"./service/amphorETH": 27244,
	"./service/amphorETH.ts": 27244,
	"./service/performance": 560,
	"./service/performance.ts": 560,
	"./service/useTVL": 599,
	"./service/useTVL.ts": 599,
	"./setupTests": 35374,
	"./setupTests.ts": 35374,
	"./themes": 85067,
	"./themes/": 85067,
	"./themes/index": 85067,
	"./themes/index.tsx": 85067,
	"./themes/typography": 78832,
	"./themes/typography.tsx": 78832,
	"./types/TVL": 27826,
	"./types/TVL.ts": 27826,
	"./types/performances": 81937,
	"./types/performances.ts": 81937,
	"./utils/faq": 93152,
	"./utils/faq.tsx": 93152,
	"./utils/functions": 21729,
	"./utils/functions.ts": 21729
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 25538;